import { render, staticRenderFns } from "./TemplatesSettings.vue?vue&type=template&id=f88dd934&"
import script from "./TemplatesSettings.vue?vue&type=script&lang=ts&"
export * from "./TemplatesSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports